(function ($){
    $(document).ready(function (){

        // Description Layouts
        function fullDescriptionLayout(){

            $("#descriptionTabs").tabs();

            $("#descriptionAccordion").accordion({
                heightStyle: "content",
                collapsible: true
            });

            // Scroll to div
            $(".tabs-information a").click(function() {
                $('html,body').animate({ scrollTop: $(".tabbed").offset().top-100 }, 'slow' );
            });
            
        }

        fullDescriptionLayout();

        if (Shopify.designMode) {
            document.addEventListener('shopify:section:load', function() {
                fullDescriptionLayout();
            });
        }        

    });
})(jQuery);